import { dom } from './dom.js';
import { Utils } from './utils.js';

export const Search = {
  clearHighlights() {
    dom.outputArea.querySelectorAll('mark.highlight').forEach((mark) => {
      mark.replaceWith(document.createTextNode(mark.textContent || ''));
    });
    dom.outputArea.normalize();
  },

  apply() {
    Search.clearHighlights();

    const query = dom.searchInput.value.trim();
    if (!query) {
      dom.searchCount.textContent = '';
      return;
    }

    const regex = new RegExp(Utils.escapeRegex(query), 'gi');
    const textNodes = [];
    const walker = document.createTreeWalker(dom.outputArea, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return node.textContent && node.textContent.trim()
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      },
    });

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    let matchCount = 0;

    textNodes.forEach((node) => {
      const text = node.textContent || '';
      regex.lastIndex = 0;
      if (!regex.test(text)) return;

      const fragment = document.createDocumentFragment();
      let lastIndex = 0;
      regex.lastIndex = 0;

      text.replace(regex, (match, offset) => {
        if (offset > lastIndex) {
          fragment.appendChild(document.createTextNode(text.slice(lastIndex, offset)));
        }

        const mark = document.createElement('mark');
        mark.className = 'highlight';
        mark.textContent = match;
        fragment.appendChild(mark);

        lastIndex = offset + match.length;
        matchCount += 1;
        return match;
      });

      if (lastIndex < text.length) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
      }

      node.parentNode.replaceChild(fragment, node);
    });

    dom.searchCount.textContent = matchCount
      ? `${matchCount} match${matchCount > 1 ? 'es' : ''}`
      : 'No matches';
  },
};
